import { create } from "zustand"
import { ContextDocumentsState } from "./types"

const useContextDocumentsStore = create<ContextDocumentsState>((set: any, get: any) => ({
	documents: [],
	addDocuments: (documents) => set({ documents: [...get().documents, ...documents] }),
	setDocuments: (documents) => set({ documents }),
}))

export { useContextDocumentsStore }
